import { useModel } from '@reduck/core';
import { commonModel } from './common';

export const useCommonModel = () => useModel(commonModel);
